export enum DKProject {
  Country = 'country',
  Group = 'group',
}
